import "./ComplianceAndDataProtection.module.css";
import Header from "@/reusable_sections/Header";
import TermsAndConditions from "./sections/TermsAndConditions";
import Footer from "@/reusable_sections/Footer";
export default function ComplianceAndDataProtectionPage() {
  return <div>
      <Header />
      <TermsAndConditions />
      <Footer />
    </div>;
}